(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["previsualisateur-pompon"] && !Shopify.designMode) return;
  try {
    
function pomClamp(v,a,b){return Math.max(a,Math.min(b,v))}
function pomHex(hex){hex=hex.replace('#','');return{r:parseInt(hex.slice(0,2),16),g:parseInt(hex.slice(2,4),16),b:parseInt(hex.slice(4,6),16)}}
function pomHSV(r,g,b){r/=255;g/=255;b/=255;const max=Math.max(r,g,b),min=Math.min(r,g,b),d=max-min;let h=0;if(d){if(max===r)h=((g-b)/d)%6;else if(max===g)h=(b-r)/d+2;else h=(r-g)/d+4;h*=60;if(h<0)h+=360}return{h:h,s:max===0?0:d/max,v:max}}
function pomRGB(h,s,v){const c=v*s,x=c*(1-Math.abs((h/60%2)-1)),m=v-c;let r=0,g=0,b=0;if(h<60)[r,g,b]=[c,x,0];else if(h<120)[r,g,b]=[x,c,0];else if(h<180)[r,g,b]=[0,c,x];else if(h<240)[r,g,b]=[0,x,c];else if(h<300)[r,g,b]=[x,0,c];else[r,g,b]=[c,0,x];return{r:Math.round((r+m)*255),g:Math.round((g+m)*255),b:Math.round((b+m)*255)}}
function pomTint(r,g,b,hex){const src=pomHSV(r,g,b),t=pomHex(hex),dst=pomHSV(t.r,t.g,t.b);const v=dst.v<.22?.035+src.v*.28:pomClamp(dst.v*(.42+.70*src.v),0,1);return pomRGB(dst.h,pomClamp(dst.s*(.55+.45*src.s),0,1),v)}
function initPomConfig(root){
 if(!root||root.dataset.ready==='1')return;root.dataset.ready='1';
 const canvas=root.querySelector('[data-pom-canvas]'),ctx=canvas.getContext('2d',{willReadFrequently:true}),status=root.querySelector('[data-pom-status]'),single=root.querySelector('[data-single-color]'),swap=root.querySelector('[data-swap]'),add=root.querySelector('[data-pom-add]'),summary=root.querySelector('[data-pom-summary]'),error=root.querySelector('[data-pom-error]'),labels=[root.querySelector('[data-color-label="1"]'),root.querySelector('[data-color-label="2"]')];
 let base,m1,m2,selected=[null,null];
 const form=()=>document.querySelector('product-form form[action*="/cart/add"]')||document.querySelector('form[action*="/cart/add"]');
 const valid=()=>!!selected[0]&&(single.checked||!!selected[1]);
 function showError(t){error.textContent=t;error.hidden=false}
 function clearError(){error.hidden=true;error.textContent=''}
 function properties(){const f=form();if(!f)return;f.querySelectorAll('[data-pom-property]').forEach(i=>i.remove());if(!valid())return;const one=single.checked,props={'Couleur 1':selected[0].name,'Couleur 2':one?selected[0].name:selected[1].name,'Configuration pompon':one?'1 couleur':'2 couleurs'};Object.entries(props).forEach(([k,v])=>{const i=document.createElement('input');i.type='hidden';i.name=`properties[${k}]`;i.value=v;i.dataset.pomProperty='1';f.appendChild(i)})}
 function state(){const one=single.checked;labels[0].textContent=selected[0]?.name||'À choisir';labels[1].textContent=one?'Identique à la couleur 1':selected[1]?.name||'À choisir';summary.textContent=!selected[0]?'Choisissez la couleur 1':(!one&&!selected[1]?`${selected[0].name} + choisissez la couleur 2`:(one?selected[0].name:`${selected[0].name} + ${selected[1].name}`));add.disabled=!valid();if(valid())clearError();properties()}
 function mask(data){const d=data.data,n=d.length/4;m1=new Uint8Array(n);m2=new Uint8Array(n);for(let p=0,i=0;p<n;p++,i+=4){const r=d[i],g=d[i+1],b=d[i+2],hsv=pomHSV(r,g,b),blue=b-Math.max(r,g),isBlue=hsv.s>.18&&((hsv.h>=176&&hsv.h<=284)||blue>18),warm=hsv.h>=8&&hsv.h<=90,gold=r>b+22&&g>b+4&&r>g*.72,isGold=hsv.s>.165&&(warm||gold);if(isBlue&&!isGold)m1[p]=1;if(isGold&&!isBlue)m2[p]=1}}
 function draw(){if(!base)return;const out=new ImageData(new Uint8ClampedArray(base.data),base.width,base.height),d=out.data;for(let p=0,i=0;p<m1.length;p++,i+=4){let z=m1[p]?0:(m2[p]?1:-1);if(z<0)continue;if(single.checked&&z===1)z=0;const choice=selected[z];if(!choice)continue;const hsv=pomHSV(d[i],d[i+1],d[i+2]),t=pomTint(d[i],d[i+1],d[i+2],choice.color),strength=Math.max(pomClamp((hsv.s-.12)/.45,0,1),.75);d[i]=Math.round(d[i]*(1-strength)+t.r*strength);d[i+1]=Math.round(d[i+1]*(1-strength)+t.g*strength);d[i+2]=Math.round(d[i+2]*(1-strength)+t.b*strength)}ctx.putImageData(out,0,0);state()}
 root.querySelectorAll('.pom-config__swatch').forEach(btn=>btn.addEventListener('click',()=>{const idx=Number(btn.closest('[data-group]').dataset.group)-1;selected[idx]={name:btn.dataset.name,color:btn.dataset.color};root.querySelectorAll(`[data-group="${idx+1}"] .pom-config__swatch`).forEach(b=>b.classList.toggle('is-selected',b===btn));draw()}));
 single.addEventListener('change',()=>{root.querySelector('[data-second-color]').classList.toggle('is-disabled',single.checked);draw()});
 swap.addEventListener('click',()=>{[selected[0],selected[1]]=[selected[1],selected[0]];root.querySelectorAll('.pom-config__swatch').forEach(b=>{const idx=Number(b.closest('[data-group]').dataset.group)-1;b.classList.toggle('is-selected',!!selected[idx]&&b.dataset.color.toUpperCase()===selected[idx].color.toUpperCase())});draw()});
 const f=form();if(f&&!f.dataset.pomGuard){f.dataset.pomGuard='1';f.addEventListener('submit',e=>{if(valid()){properties();return}e.preventDefault();e.stopImmediatePropagation();showError(single.checked?'Choisissez la couleur de votre pompon avant de l’ajouter au panier.':'Choisissez les deux couleurs de votre pompon avant de l’ajouter au panier.');root.scrollIntoView({behavior:'smooth',block:'center'})},true)}
 add.addEventListener('click',()=>{if(!valid()){showError(single.checked?'Choisissez la couleur de votre pompon.':'Choisissez les deux couleurs de votre pompon.');return}const pf=form();if(!pf){showError('Le formulaire d’achat Shopify est introuvable.');return}properties();const submit=pf.querySelector('button[type="submit"],input[type="submit"]');if(pf.requestSubmit)pf.requestSubmit(submit||undefined);else pf.submit()});
 const img=new Image();img.crossOrigin='anonymous';img.onload=()=>{const scale=Math.min(1,900/img.naturalWidth);canvas.width=Math.round(img.naturalWidth*scale);canvas.height=Math.round(img.naturalHeight*scale);ctx.drawImage(img,0,0,canvas.width,canvas.height);base=ctx.getImageData(0,0,canvas.width,canvas.height);mask(base);state();status.textContent='Aperçu indicatif — les reflets réels peuvent légèrement varier.'};img.onerror=()=>status.textContent='Impossible de charger l’image du pompon.';img.src=root.dataset.image;
}
function initAllPomConfigs(scope){(scope||document).querySelectorAll('[data-pom-config]').forEach(initPomConfig)}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initAllPomConfigs(document));else initAllPomConfigs(document);document.addEventListener('shopify:section:load',e=>initAllPomConfigs(e.target));

  } catch(e) { console.error(e); }
})();
})();
